import { el } from 'redom';

import application from 'application';

import internalEventCodes from 'event-system/codes/internal';

import DialogCloseButton from 'generics/components/dialog-close-button';
import SaveButton from 'generics/components/save-button';
import TextInput from 'generics/components/text-input';
import HorizontalToggle from 'generics/components/horizontal-toggle/native';

class LabelDialog {

  constructor(configuration, dialogCallbacks) {

    this.onComplete = dialogCallbacks.onComplete;
    this.onClose = dialogCallbacks.onClose;

    this.labelInput = null;
    this.publicToggle = null;

    this.el = el('.favourite-node-label-main', [
      this.renderHeaderSection(),
      this.renderBodySection()
    ]);

  }

  onmount() {

    this.labelInput.focus();

  }

  renderHeaderSection() {

    return el('.dialog-header', [
      el('.dialog-header-text', 'Favourite node'),
      new DialogCloseButton({ onClick: this.handleDialogCloseButtonClick.bind(this) })
    ]);

  }

  renderLabelInput() {

    this.labelInput = new TextInput({
      placeholder: 'Ex: Contact form'
    });

    return this.labelInput;

  }

  renderSaveButton() {

    return new SaveButton({
      onClick: this.handleSaveButtonClick.bind(this),
      label: 'Create'
    });

  }

  renderPublicInput() {

    this.publicToggle = new HorizontalToggle({
      label: 'Public',
      value: false,
      onChange() {}
    });

    return this.publicToggle;

  }

  renderBodySection() {

    return el('form.favourite-node-label-form', {
      onsubmit: this.handleSaveButtonClick.bind(this)
    }, [
      el('.form-input-controls-section', [
        el('.form-input-row.columns', [
          el('.field-label', 'Label'),
          this.renderLabelInput()
        ]),
        this.renderPublicInput()
      ]),
      el('.form-button-controls-section', [
        this.renderSaveButton()
      ])
    ]);

  }

  handleDialogCloseButtonClick() {

    this.onClose();

  }

  handleSaveButtonClick() {

    const label = this.labelInput.value.trim();

    if (label === '') {
      application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
        message: 'Please enter some text',
        seconds: 5,
        type: 'erro'
      });
      this.labelInput.focus();
      return;
    }

    this.onComplete({
      label: this.labelInput.value,
      public: this.publicToggle.value
    });

  }

}

export default LabelDialog;